<template>
  <div class="uk-grid" data-uk-grid>
    <div class="uk-width-1-1" v-for="vehicleOffers in offers" :key="vehicleOffers.id">
      <div class="uk-card uk-card-small uk-card-default uk-box-shadow-small uk-margin-bottom">
        <div class="uk-card-header">
          <h3 class="uk-card-title">
            <div class="uk-flex uk-flex-between">
              <div>
                {{ vehicleOffers[0].merchant.company }}
              </div>
              <div>
                <span class="uk-h5">Angebotsdatum: {{ vehicleOffers[0].created }}</span>
              </div>
            </div>
          </h3>
        </div>
        <div class="uk-card-body uk-padding-remove">
          <table class="uk-table uk-table-hover uk-table-middle uk-table-divider">
            <thead>
              <tr style="background: #6f6f6f">
                <th class="uk-table-expand"></th>
                <th v-for="offer in vehicleOffers[0].data" :key="offer.id" style="color: #fff;">
                  <div class="uk-text-bold">Laufzeit {{ offer.duration }} Monate</div>
                  <div class="uk-text-bold">{{ offer.mileage | mileage }}</div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Gewünschte Anzahl ({{ totalQuantity(vehicleOffers[0]) }} / {{ availableQuantity }} )</td>
                <td v-for="offer in vehicleOffers[0].data" :key="offer.id">
                  {{ offer.quantity }}
                </td>
              </tr>
              <tr>
                <td>
                  Restwert in %
                </td>
                <td v-for="offer in vehicleOffers[0].data" :key="offer.id">
                  {{ offer.percent }} %
                </td>
              </tr>
              <tr>
                <td>Restwert in EURO</td>
                <td v-for="offer in vehicleOffers[0].data" :key="offer.id">
                  {{ calculatedPrice(offer.percent) | euro }}
                </td>
              </tr>
              <tr>
                <td>Frachtkosten</td>
                <td v-for="offer in vehicleOffers[0].data" :key="offer.id">
                  {{ formatedShippingCosts | euro }}
                </td>
              </tr>
              <tr style="background: #6f6f6f;color: #fff;">
                <td class="uk-text-bold">Rückkaufwertangebot</td>
                <td v-for="offer in vehicleOffers[0].data" :key="offer.id">
                  <span class="uk-text-bold">{{ (calculatedPrice(offer.percent) + formatedShippingCosts) | euro }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    offers: {
      type: Array,
      required: true
    },
    shippingCosts: {
      required: true
    },
    price: {
      required: true
    },
    availableQuantity: {
      required: true
    }
  },
  computed: {
    formatedShippingCosts() {
      return this.shippingCosts / 100
    },
  },
  methods: {
    calculatedPrice(percent) {
      return (this.price / 100) * percent / 100
    },
    totalQuantity(offers) {
      let sum = 0;
      offers.data.forEach(offer => {
        sum += parseFloat(offer.quantity);
      })

      return sum
    }
  }
}
</script>